<ng-content></ng-content>
<div class="w-full flex flex-col lg:flex-row gap-4">
  <!-- Edit Form Section -->
  <div class="w-full lg:w-1/2 shadow-md rounded-xl p-4 bg-[var(--text-light)]">
    <form [formGroup]="editNewsForm" (ngSubmit)="submit()" class="space-y-4">
      <!-- Title -->
      <div class="space-y-2">
        <label for="title" class="block text-md font-semibold">العنوان</label>
        <input pInputText type="text" id="title" name="title" placeholder="ادخل العنوان"
          class="w-full shadow-sm rounded-lg p-2" formControlName="title" />
      </div>

      <!-- Cover Image -->
      <div class="space-y-2">
        <label for="cover_image" class="block text-md font-semibold">صورة الغلاف</label>
        <p-fileUpload name="demo[]" customUpload="true" [multiple]="false" chooseLabel="اختر صورة" cancelLabel="الغاء"
          accept="image/jpeg,image/png,image/gif,image/webp" [showUploadButton]="false" [showCancelButton]="false"
          chooseIcon="pi pi-image ml-2" styleClass="w-full shadow-sm rounded-lg overflow-hidden"
          (onSelect)="onSelect($event)" (onClear)="onClear()" (onRemove)="onRemove($event)">
          <ng-template pTemplate="content">
            <div class="flex items-center gap-3 p-2 bg-slate-50 rounded-lg">
              <p class="text-sm text-slate-600">الغلاف الحالي:</p>
              <img [src]="editNewsForm.get('cover_image')?.value" alt="Current Cover"
                class="w-12 h-12 object-cover rounded-lg shadow-sm">
            </div>
          </ng-template>
        </p-fileUpload>
      </div>

      <!-- Editor -->
      <div class="mt-4" style="direction: ltr !important">
        <p-editor formControlName="content" placeholder="هنا تكتب الخبر..."
          styleClass="shadow-sm rounded-lg overflow-hidden" [style]="{'height': '300px'}">
        </p-editor>
      </div>

      <!-- Action Buttons -->
      <div class="flex flex-wrap gap-2 pt-4">
        <p-button type="submit" label="حفظ" severity="success" class="w-full sm:w-auto"></p-button>
        <p-button type="button" label="معاينة قبل الحفظ" severity="info" (onClick)="preview()"
          class="w-full sm:w-auto"></p-button>
      </div>
    </form>
  </div>

  <!-- Preview Section -->
  <div class="w-full lg:w-1/2">
    <div class="shadow-md rounded-xl bg-[var(--text-light)] h-[calc(100vh-2rem)] overflow-hidden">
      <div class="p-4 h-full overflow-y-auto">
        <h1 class="text-xl sm:text-2xl font-bold text-center mb-4">المعاينة</h1>
        <hr class="mb-4 opacity-20">

        <!-- Preview Image -->
        <div class="relative rounded-lg overflow-hidden mb-6">
          <img *ngIf="previewText?.image_url" [src]="previewText?.image_url" alt="Preview"
            class="w-full h-[200px] sm:h-[300px] object-cover">
        </div>

        <!-- Preview Title -->
        <h1 *ngIf="previewText?.title" class="text-xl sm:text-2xl font-bold text-center mb-6">
          العنوان: {{previewText?.title}}
        </h1>

        <!-- Preview Content -->
        <div #tag_container class="img-cont prose prose-sm max-w-none" [innerHTML]="previewText?.text">
        </div>
      </div>
    </div>
  </div>
</div>